import React from 'react';
import classNames from 'classnames';
import withPGTranslation from '../../../config/withPGTranslation';
import classes from '../classes.module.scss';
import { getReviewCount } from '../../../config/util';
import { SvgIcon } from '../../../../common/sprites';

const getRatingText = (rating) => {
  if (!rating && rating !== 0) return <div className={ classes.ratingTextSkeleton } suppressHydrationWarning />;
  return parseFloat(rating).toFixed(1);
};

const getRatingContaineritemProp = (reviewCount, rating, needAddItemProp) => {
  if (reviewCount > 0 && rating > 0 && needAddItemProp) {
    return { itemProp:'aggregateRating', itemScope:'itemScope', itemType:'http://schema.org/AggregateRating' };
  }
  return null;
};

const addMetaTag = (reviewCount, rating, needAddItemProp) => {
  if (reviewCount > 0 && rating > 0 && needAddItemProp) {
    return (
      <>
        <meta id="metaTagItemPropRatingCount" content={ `${ reviewCount }` } itemProp="ratingCount" suppressHydrationWarning />
        <meta id="metaTagItemPropRatingValue" content={ `${ (parseFloat(rating)) }` } itemProp="ratingValue" suppressHydrationWarning />
      </>
    );
  }
  return null;
};

function Rating({
  rating,
  isNewAdvisor,
  likesCount,
  dislikesCount,
  needAddItemProp,
  theme,
  className
}) {
  if (!rating || isNewAdvisor) {
    return null;
  }

  const reviewCount = getReviewCount({ likesCount, dislikesCount });

  const renderRating = () => (
    <div className={ classes[`${ theme }`] }>
      <div
        className={ classNames(classes.ratingContainer, className) }
        { ...getRatingContaineritemProp(reviewCount, rating, needAddItemProp) }
        suppressHydrationWarning
      >
        <SvgIcon id="star_icon" className={ classes.starImg } suppressHydrationWarning />
        <div className={ classes.ratingText } suppressHydrationWarning>
          { getRatingText(rating) }
        </div>
        { addMetaTag(reviewCount, rating, needAddItemProp) }
      </div>
    </div>
  );

  return renderRating();
}

export default withPGTranslation(Rating);
